import React from 'react';

const SparkleStar = ({ style }) => (
  <svg 
    className="sparkle" 
    style={style} 
    viewBox="0 0 160 160" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M80 0C80 0 84.5 59.5 160 80C160 80 84.5 100.5 80 160C80 160 75.5 100.5 0 80C0 80 75.5 59.5 80 0Z" 
      fill="currentColor"
    />
  </svg>
);

export default SparkleStar;
